module.exports = __webpack_public_path__ + "static/media/intro_icon_8.88265ab2.svg";